enum JourneyIconStepTypes {
    IconClass101 = 'class-101',
    IconClass201 = 'class-201',
    IconClass301 = 'class-301',
    IconClass401 = 'class-401',
}

export default JourneyIconStepTypes;
